<template>
        <v-card class="bg-card mb-2" flat>
            <v-card-text>

                <v-card class="content bg-card" elevation="0" xstyle="min-width:320px;">

                    <v-card-title>                        
                        <label>Licenties</label>

                        <v-spacer></v-spacer>
                        <TipMenu>
                            <p><h4>Medewerker urenlijsten zijn beschikbaar in buitendienst app</h4></p>
                            <p>
                                Met deze optie kunt u de urenlijsten va deze medewerker beschikbaar maken in de buitendienst app.
                                Wanneer deze medewerker in de app kan inloggen, kan de medewerker zelf de urenlijsten invullen. <br>
                            </p>
                            <p>
                                Wanneer deze medewerker geen toegang heeft tot de buitendienst app kunt u een andere medewerker toegang geven tot de urenlijsten van deze medewerker. 
                                Op deze manier kunt u de urenlijsten van deze medewerker laten invullen door een andere medewerker. <br>
                            </p>
                            <p>
                                Let op dat deze optie kosten met zich meebrengt. Zie <a target="_blank" href="https://www.optimit.nl/prijzen">onze prijzenpagina</a>.
                                U kunt deze optie op elk moment weer uitzetten.
                            </p>
                        </TipMenu>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row dense>
                            <v-col sm="auto"><Checkbox label="Urenregistratie in buitendienst-app" :model="model" xclass="d-inline-block width-auto" v-model="model.can_app_hours"></Checkbox></v-col>
                        </v-row>
                            <Radiogroup v-if="model.can_app_hours" class="ml-6 mt-2" :model="model" v-model="model.hours_manage_employees">
                                <v-row  dense>
                                     <v-col sm="auto">
                                         <Radio :model="model" value="own" label="Medewerker kan eigen uren beheren"/>
                                     </v-col>
                                     <v-col>
                                        <TipMenu>
                                            <p><h4>Een medewerker met deze rechten:</h4></p>
                                            <p>
                                                <UlCustom>
                                                    <LiCustom check>Heeft alleen toegang tot zijn eigen urenstaten</LiCustom>    
                                                </UlCustom>                                                
                                            </p> 
                                        </TipMenu>

                                     </v-col>
                                </v-row>                                     
                                <v-row dense>
                                    <v-col sm="auto">
                                         <Radio :model="model" value="all" label="Medewerker kan alle uren beheren"/>
                                     </v-col>
                                     <v-col>
                                        <TipMenu>
                                            <p><h4>Een medewerker met deze rechten:</h4></p>
                                            <p>
                                                <UlCustom>
                                                    <LiCustom check>Heeft in de buitendienst app toegang tot de urenstaten van alle medewerkers.</LiCustom>    
                                                    <LiCustom check>Kan van alle medewerker de urenstaten invullen</LiCustom>    
                                                </UlCustom>
                                            </p> 
                                        </TipMenu>

                                     </v-col>
                                </v-row>                            
                                <v-row dense>
                                    <v-col sm="auto">
                                         <Radio :model="model" value="custom" label="Medewerker kan uren beheren van zichzelf en geselecteerde medewerkers"/>
                                         <div v-if="model.hours_manage_employees=='custom'" class="ml-8 mt-2">
                                            <EmployeesCombo :model="model" v-model="model.hours_employees"></EmployeesCombo>
                                         </div>
                                        </v-col>
                                     <v-col>
                                        <TipMenu>
                                            <p><h4>Een medewerker met deze rechten:</h4></p>
                                            <p>
                                                <UlCustom>
                                                    <LiCustom check>Heeft in de buitendienst app toegang tot de urenstaten van onder geselecteerde medewerkers.</LiCustom>    
                                                    <LiCustom check>Kan van de geselecteerde medewerker de urenstaten invullen</LiCustom>    
                                                </UlCustom>
                                            </p> 
                                        </TipMenu>

                                     </v-col>
                                </v-row>                            
                            </Radiogroup>

                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-text>
                        <v-row dense>
                            <v-col sm="auto"><Checkbox label="Werkbonnen in buitendienst-app" :model="model" xclass="d-inline-block width-auto" v-model="model.can_app_workorders"></Checkbox></v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4" xstyle="min-width:320px;">

                    <v-card-title>
                        <label>App login</label>
                        <v-spacer></v-spacer>
                        <TipMenu>
                            <p><h4>App login</h4></p>
                            <p>
                                Met deze optie kunt u aangeven of deze medewerker mag inloggen in de buitendienst app.<br>
                                De gebruiker moet zijn inloggegevens hebben ontvangen en geactiveerd.
                            </p>
                        </TipMenu>

                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text v-if="model.acceptedUser">
                        <span class="pa-2 bordered bg-disabled">
                            {{model.acceptedUser}}
                        </span>
                        <span class="ml-4">
                            <ActionButton main primary @click='removeUser'>Ontkoppel gebruiker</ActionButton>
                        </span>
                    </v-card-text>
                    <v-card-text v-else-if="model.invitedUser">
                        <div class="text-italic mb-2">Gebruiker is uitgenodigd maar heeft nog niet geaccepteerd</div> 
                        <span class="pa-2 bordered bg-disabled">
                            {{model.invitedUser}}
                        </span>
                        <ActionButton ml main @click='removeInvitation'>Verwijder uitnodiging</ActionButton>
                        <ActionButton ml main primary @click='resendInvitation'>Stuur nogmaals</ActionButton>
                    </v-card-text>
                    <v-card-text v-else>
                        <p>
                            Geen gebruiker gekoppeld.
                        </p>
                        <ActionButton main primary @click='inviteUser'>Koppel gebruiker</ActionButton>
                    </v-card-text>
                </v-card>
                <v-card class="mt-4" xstyle="min-width:320px;">

                    <v-card-title>
                        <label>App toegang</label>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <AlertArea class="mb-2" v-if="!model.acceptedUser&&!model.invitedUser" info icon>
                            Deze instellingen zijn alleen van toepassing wanneer de App-logingegevens zijn aangemaakt.
                        </AlertArea>

                        <v-row dense>
                            <v-col><Checkbox label="Medewerker kan inloggen" :model="model" xclass="d-inline-block width-auto" v-model="model.can_app_login"></Checkbox>
                            </v-col>
                            <v-col sm="auto">
                            <TipMenu>
                                <p><h4>Medewerker kan inloggen</h4></p>
                                <p>
                                    Met deze optie kunt u de medewerker toegang geven tot de buitendienst app, of de toegang blokkeren zonder de gebruiker te verwijderen. 
                                </p> 
                            </TipMenu>

                            </v-col>
                        </v-row>
                    </v-card-text>
                    </v-card>
            </v-card-text>

            <Prompt title="Nodig gebruiker uit" save="Ga door" :model="prompt">
                <FormRow label="Naam">    
                    <TextField :model='prompt' :rules='model.rules.mandatory' v-model='prompt.name'></TextField>
                </FormRow>
                <FormRow label="E-mail">    
                    <TextField :model='prompt' :rules='model.rules.mandatory' v-model='prompt.email'></TextField>
                </FormRow>
            </Prompt>

        </v-card>
</template>



<script setup>
    
    import feature from '@app/features'
    import Checkbox from '@controls/check/Checkbox.vue'
    import UlCustom from "@controls/list/UlCustom"
    import LiCustom from "@controls/list/LiCustom"
    import Radiogroup from "@controls/check/Radiogroup.vue";
    import Radio from "@controls/check/Radio.vue";
    import TipMenu from "@controls/menu/TipMenu.vue";
    import EmployeesCombo from '@controls/combo/Employees'
    import AlertArea from '@shared/ui/markup/AlertArea'
    import ActionButton from '@controls/buttons/ActionButton'
    import noty from '@shared/lib/noty'

    import Prompt from '@shared/ui/dialogs/DialogCustomPrompt'
    import clsDialogCustomPrompt from '@cls/clsDialogCustomPrompt'
    import FormRow from '@controls/forms/FormRow'
    import TextField from '@controls/input/TextField'
    import {ref} from 'vue'

    const props = defineProps({
        model: {
            type: [Object]
        },
        dlg: {
            type: [Object]
        },
    });

    let prompt = ref(new clsDialogCustomPrompt(["email", "name"]));

    async function removeUser() {
        if (!await noty.tryConfirm('Weet u zeker dat u deze gebruiker wilt ontkoppelen?<br>Hierna kan deze medewerker niet meer inloggen in uw organisatie.')){
            return;
        }
        await props.model.removeUser();
    }
    async function resendInvitation() {
        if (!await noty.tryConfirm('Weet u zeker dat u de uitnodiging opnieuw wilt sturen?')){
            return;
        }
        await props.model.resendInvitation();
        noty.snack.info('De Uitnodiging is verzonden');
    }
    async function removeInvitation() {
        if (!await noty.tryConfirm('Weet u zeker dat u de uitnodiging wilt verwijderen?')) {
            return;   
        }
        await props.model.removeInvitation();
    }

    async function inviteUser() {
        let result = await props.dlg.onSave(true);
        if (result === false) {
            return; // Validation failed.
        }

        prompt.value.setData({email: props.model.email, name: `${props.model.firstname} ${props.model.lastname}`})
                    .prompt( async (obj) => props.model.inviteUser(obj.email, obj.name))
        
    }

</script>
